import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setLanguage } from 'redux-i18n';
import moment from 'moment';

import { formatDate, setBookingData } from 'bookingform';
import {
  setOrigin,
} from 'bookingform/dist/export/actions';
//import { formatDate, setBookingData, setFormVisible } from 'bookingform';
import SearchMinStay from './SearchMinStay';
import {
  startSearch,
  clearRoomSelection,
  setFilterCategory, sendGTMEvents, setAgentCode, setRateType, setAgentSell,
  setAgentUseCoins,
  setBookLocator,
} from '../actions/Booking';
import { getCheckInCheckOutDaysFrom } from '../utils/Generic';
import { paramToDistribution } from '../utils/Room';
import withNavigate from '../withNavigate'; // Importa el HOC

import {
  chains, CALL_CENTER_ROLE, FREE_MODE_DISTRIBUTION, LONG_DAY_NAME,
} from '../constants';

import sandosLogo from '../static/images/SANDOS_logo_lg.png';
import marconfortLogo from '../static/images/MARCONFORT_logo_lg.png';
import palmaiaLogo from '../static/images/PALMAIARESORTS_logo_lg.png';

import '../static/less/pages/search.less';
import { store } from '../Store';

const chainLogos = {
  SANDOS: sandosLogo,
  MARCONFORT: marconfortLogo,
  PALMAIARESORTS: palmaiaLogo,
};

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchError: false,
    };
  }

  componentDidMount() {
    // We only can validate the parameters if we have the some bookingform's data stored in the reducer.
    // For example, the hotels list...
    if (this.isFormLoaded(this.props) && (this.props.params.session || this.props.sessionId)) {
      this.initiateComponent(this.props);
    }

    // Set the form to hidden to display the BookingFormSummary instead
    //this.props.dispatch(setFormVisible(false));
    // Pidieron que no se ocultara el booking form
  }

  // If is the first time that user arrive here, we have not the basic data from de bookingform (like hotels list).
  // The initiateComponent has not been executed. When bookingform receive the data, this event will be fired and
  // then we will execute the initiateComponent.
  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    // For better readability, we check if it is necessary to initiate component in multiple lines.
    if (!this.isFormLoaded(this.props) && this.isFormLoaded(nextProps)) {
      return this.initiateComponent(nextProps);
    }

    if (this.props.location.key !== nextProps.location.key
      || this.props.location.action !== nextProps.location.action) {
      return this.initiateComponent(nextProps);
    }

    // If the language change, we go to update the moment locale.
    if (nextProps.lang !== this.props.lang) {
      moment.locale(nextProps.lang);
    }
    return null;
  }

  isFormLoaded(props) {
    return (props.session || props.sessionId) && props.countries.length > 0;
  }

  // Return the searched hotel...
  getSearchHotel(params, countries) {
    let searchHotel = null;
    countries.forEach((country) => {
      country.zones.forEach((zone) => {
        const found = zone.hotels.find((hotel) => hotel.pk === parseInt(params.destId, 10));
        if (found) {
          searchHotel = found;
        }
      });
    });
    return searchHotel;
  }

  // Return the searched zone...
  getSearchZone(params, countries) {
    let searchZone = null;
    countries.forEach((country) => {
      const found = country.zones.find((zone) => zone.pk === params.destId);
      if (found) {
        searchZone = found;
      }
    });
    return searchZone;
  }

  // Return the searched agentCode
  getSearchAgentCode(params) {
    return params.agentCode;
  }

  // Return the searched agentSell
  getSearchAgentSell(params) {
    return params.agentSell;
  }

  // Return the searched rateType
  getSearchRateType(params) {
    if (params.rateType === 'PUBLIC_RATE' || params.rateType === 'NET_RATE') {
      return params.rateType;
    }
    return 'PUBLIC_RATE';
  }

  // Return the searched agentUseCoins (now read from query parameter)
  getSearchAgentUseCoins() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const agentUseCoins = queryParams.get('agentUseCoins');
    if (agentUseCoins === 'true' || agentUseCoins === 'false') {
      return agentUseCoins;
    }
    return 'true';
  }

  getSearchDates(params, withFormat) {
    const { daysFromCheckIn, daysFromCheckOut } = params;
    if (daysFromCheckIn && daysFromCheckOut) {
      return getCheckInCheckOutDaysFrom(daysFromCheckIn, daysFromCheckOut, withFormat);
    }
    return getCheckInCheckOutDaysFrom(params.checkIn, params.checkOut, withFormat);
  }

  getDistributionValue(paramDistri) {
    let distri = paramDistri;
    if (!paramDistri || (paramDistri === FREE_MODE_DISTRIBUTION && !this.props.isCallCenterUser)) {
      distri = '2-0-0';
    }
    return paramToDistribution(distri);
  }

  // Check all uri string parameters. If all are right, the new search action will be fired.
  initiateComponent(props) {
    const { params, countries, sessionId } = props;
    if (this.areParamsValid(params, countries, sessionId)) {
      this.setState({ searchError: false });

      const hotel = this.getSearchHotel(params, countries);
      const zone = this.getSearchZone(params, countries);
      const { checkIn, checkOut } = this.getSearchDates(params, true); // dates as string

      this.props.dispatch(setBookLocator(null));

      let agentCode = this.getSearchAgentCode(params);
      if (agentCode === '-') {
        agentCode = '';
      }
      const agentSell = this.getSearchAgentSell(params);
      const rateType = this.getSearchRateType(params);
      const agentUseCoins = this.getSearchAgentUseCoins();
      this.props.dispatch(setAgentCode(agentCode));
      this.props.dispatch(setAgentSell(agentSell));
      this.props.dispatch(setRateType(rateType));
      this.props.dispatch(setAgentUseCoins(agentUseCoins));

      const state = store.getState();
      state.bookingFormState.agentCode = agentCode;
      state.bookingFormState.agentSell = agentSell;
      state.bookingFormState.rateType = rateType;
      state.bookingFormState.agentUseCoins = agentUseCoins;
      this.props.dispatch(setOrigin(this.props.params.origin ? this.props.params.origin : 'BOOKING'));
      this.props.dispatch(setBookingData({
        checkIn,
        checkOut,
        distributions: this.getDistributionValue(params.distributions),
        dest: zone || hotel,
        promoCode: params.promoCode || '',
        chain: params.chain || this.props.chain,
        origin: params.origin,
        agentCode,
        rateType,
        agentSell,
        agentUseCoins,
      }));

      this.props.dispatch(setLanguage(params.lang || 'en'));
      this.props.dispatch(setAgentCode(agentCode));
      this.props.dispatch(setAgentSell(agentSell));

      // Clear previous room selection and launch a new search
      this.props.dispatch(clearRoomSelection(false)); // skip "emptyCartEvent" as it will be triggered by RoomList
      this.props.dispatch(setFilterCategory({ code: 'cat_all' })); // set the default category to 'all'.
      const gtmEvent = {
        event: 'destinationSearch',
        gtm: { elementClasses: zone ? zone.name : null },
      };
      if (zone && zone.name) {
        this.props.dispatch(sendGTMEvents([gtmEvent]));
      }
      this.props.dispatch(startSearch(this.context, this.props.navigate));
    } else {
      //  console.log('error params not valid');
      this.setState({ searchError: true });
    }
  }

  // Check all url parameters...
  areParamsValid(params, countries, session) {
    const {
      distributions,
      lang,
      chain,
    } = params;

    // Only valid languages...
    const { languages } = this.props.chainData.booking_engine_configuration;
    const languageCodes = languages.map((language) => language.code);
    if (languageCodes.indexOf(lang) === -1) {
      return false;
    }

    // Only valid chains...
    if (chain && chains.indexOf(chain) === -1) {
      return false;
    }

    // Validate session: either a real session or a token for certain URLs
    if (!session || (session.length < 32 && session !== 'share-url')) {
      return false;
    }

    // Checking dates as moment objects...
    const { checkIn, checkOut } = this.getSearchDates(params, false);
    if (!checkIn.isValid() || !checkOut.isValid() || !checkOut.isAfter(checkIn)) {
      return false;
    }

    // Checking if distributions are correct
    if (!/^(ANY|(\d-\d-\d,?)+)$/.test(distributions)) {
      return false;
    }

    // Finally, we check the hotel requested is found.
    return this.getSearchHotel(params, countries) !== null || this.getSearchZone(params, countries) !== null;
  }

  renderSearchedHotel() {
    return (
      <h2>
        {this.props.destination.name.toUpperCase()}&nbsp;-&nbsp;
        {this.props.destination.city && (
          <span>{`${this.props.destination.city.name}`}</span>
        )}
      </h2>
    );
  }

  renderDates(checkIn, checkOut) {
    // If the format includes the day names, then we add them to the default formatted date
    const checkInDayName = `${moment(checkIn).format(LONG_DAY_NAME)}`;
    const checkOutDayName = `${moment(checkOut).format(LONG_DAY_NAME)}`;

    const params = {
      dateIn: `${checkInDayName} ${formatDate(checkIn, this.props.lang, this.props.chain)}`,
      dateOut: `${checkOutDayName} ${formatDate(checkOut, this.props.lang, this.props.chain)}`,
    };
    return (
      <h3>
        {this.context.t('{dateIn} to {dateOut}', params)}
      </h3>
    );
  }

  renderError() {
    return (
      <div className="row Search">
        <div className="col-md-12">
          <p>{this.context.t('Sorry, but there are errors in your search. Please, check the parameters and try again.')}</p>
        </div>
      </div>
    );
  }

  renderWaitScreen(checkIn, checkOut) {
    return (
      <div className="row Search">
        <div className="col-md-12">
          <img src={chainLogos[this.props.chain]} className="logo"/>
          <div className="loader-sandos">
            {this.context.t('Loading')}...
          </div>
          <h1>{this.context.t('Checking availability for your booking:')}</h1>
          {this.props.destination && this.renderSearchedHotel()}
          {this.renderDates(checkIn, checkOut)}
        </div>
      </div>
    );
  }

  render() {
    // Search finished with an error
    if (this.state.searchError) {
      return this.renderError();
    }

    moment.locale(this.props.lang);
    const checkIn = moment(this.props.checkIn);
    const checkOut = moment(this.props.checkOut);
    // Search is still in progress
    if (this.props.availLoading) {
      return this.renderWaitScreen(checkIn, checkOut);
    }
    // Search finished with no availability due to minimum stay days
    return <SearchMinStay checkIn={checkIn} />;
  }
}

Search.propTypes = {
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

Search.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  countries: state.bookingFormState.countries || [],
  chain: state.bookingFormState.chain,
  destination: state.bookingFormState.destination,
  checkIn: state.bookingFormState.checkIn,
  checkOut: state.bookingFormState.checkOut,
  agentCode: state.bookingFormState.agentCode,
  agentSell: state.bookingFormState.agentSell,
  lang: state.i18nState.lang,
  availLoading: state.booking.availLoading,
  sessionId: state.bookingFormState.sessionId,
  isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
  chainData: state.session.chainData,
});

const ConnectedSearch = connect(mapStateToProps)(Search);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedSearch);
